import React, { useState } from 'react';
import '../styles/Page.css';

function Page() {
    return (
        <div className='page'>
            <div>
                <img src="img/PC1.png" />
                <video src="img/PC.mp4" controls></video>
                <p style={{ textAlign: 'right' }}><i>Proto Carbon</i>, 202?. Multimedia, ???, ???. </p>
                <br />
            </div>
        </div>

    )
}

export default Page;